import { render } from "./formgroupselect2.vue?vue&type=template&id=7471c714"
import script from "./formgroupselect2.vue?vue&type=script&lang=js"
export * from "./formgroupselect2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__